import { useContext } from 'react'

import { UserPreferenceProviderContext } from './UserPreferenceProviderContext'

export const useUserPreference = () => {
  const context = useContext(UserPreferenceProviderContext)

  return context
}
